import { DataModelActionType } from '../enum/DataModelActionType'

export const DefaultAvailableDataModelActionTypes: DataModelActionType[] = [
  DataModelActionType.Create,
  DataModelActionType.ReadInput,
  DataModelActionType.Read,
  DataModelActionType.Update,
  DataModelActionType.Delete,
]
